
import { useEffect, useState } from 'react';
import { useMsal } from "@azure/msal-react";
import { trackUserPageActivity } from '../Samarth Module/api/userPageTracking';

export const usePageTracking = (tabLabel) => {
    const { accounts } = useMsal();
    const activeAccount = accounts[0] || null;
    const email = activeAccount?.username;

    const [persona, setPersona] = useState("");

    useEffect(() => {
        try {
            const storedUserInfo = localStorage.getItem('UserInfo');
            if (storedUserInfo) {
                const userInfo = JSON.parse(storedUserInfo);
                setPersona(userInfo?.user_info?.persona);
            }
        } catch (error) {
            console.error('Error getting persona from localStorage:', error);
        }
    }, []);

    useEffect(() => {
        if (email && persona && tabLabel) {
            trackUserPageActivity(email, persona, tabLabel)
                .catch((err) => console.error('Error tracking page activity:', err));
        }
    }, [email, persona, tabLabel]);
};
